import NavBar from '../../components/NavBar/NavBar';
import './Home.css';
import promoBanner from '../../img/hero-promo-banner.svg';
import featureBanner from '../../img/hero-topfeature-banner.svg';
import CategoriesList from '../../components/CategoriesList/CategoriesList';
import Footer from '../../components/Footer/Footer';
import lowPriceIcon from '../../img/low-prices-icon.svg';
import twentyfoursevenIcon from '../../img/24-7-icon.svg';
import eWalletIcon from '../../img/e-wallet-icon.svg';
import homePromoBannerImage from '../../img/home-promo-image.png';

const Home = () => {

    window.scrollTo({ top: 0, behavior: "smooth" });
    console.log(localStorage.getItem("sessionId"));
    console.log(localStorage.getItem("userId"));
    console.log(localStorage.getItem("userFullName"));


    return (
        <>
            <NavBar />
            <div className="home-hero-banner">
                <div className="home-hero-leftsection">
                    <div className="home-hero-leftsection-imagewrapper">
                        <img src={homePromoBannerImage}></img>
                    </div>
                    <div className="home-hero-leftsection-bodysection">
                        <div>
                            <h5 className="promo-text-heroimage">PROMO</h5>
                            <div className="home-hero-underline-title"></div>
                        </div>
                        <h2 className="home-heroimage-title">Men's Watch <br></br> Yogya Kambas</h2>
                        <h4 className="home-heroimage-body">
                            MATOA Way Kambas - Kayu ini dipilih untuk<br></br> merepresentasikan kulit Badak Jawa yang <br></br>didesain dengan efek overlap pada strapnya<br></br> untuk merepresentasikan kulit Badak.
                        </h4>
                    </div>
                </div>
                <div className="home-hero-rightsection">
                    <div>
                        <img src={lowPriceIcon}></img>
                        <h6>Jaminan harga termurah</h6>
                    </div>
                    <div>
                        <img src={twentyfoursevenIcon}></img>
                        <h6>Tersedia 24/7</h6>
                    </div>
                    <div>
                        <img src={eWalletIcon}></img>
                        <h6>Terintegrasi dengan e-wallet</h6>
                    </div>
                </div>
            </div>
            <CategoriesList />
            <Footer />
        </>
    )
};

export default Home;